// Re-export SDE multi-select options from the main Listings
// These are used in both Pop A and Pop B registration forms
export { SDE2024MultiSelectOptionsA, SDE2024MultiSelectOptionsB, valuesToOptions } from '../../Utils/Listings';

// SDE-specific constants

export const POPULATION_TYPES = {
  POP_A: 'pop_a',
  POP_B: 'pop_b',
};

export const REGISTRATION_STATUS = {
  DRAFT: 'draft',
  SUBMITTED: 'submitted',
  VALIDATED: 'validated',
  REJECTED: 'rejected',
};

export const CANDIDATURE_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  REJECTED: 'rejected',
  WAITLISTED: 'waitlisted',
};

export const ATTENDANCE_MODES = [
  { value: 'physical', label_fr: 'Rencontres physiques uniquement', label_en: 'Physical meetings only' },
  { value: 'online', label_fr: 'Rencontres en ligne uniquement', label_en: 'Online meetings only' },
  { value: 'both', label_fr: 'Les deux (physique et en ligne)', label_en: 'Both (physical and online)' },
];

export const MAX_CANDIDATURES = 15;

export const STEPS_POP_A = [
  { key: 'representative', label_fr: 'Représentant', label_en: 'Representative', sublabel_fr: 'Informations de contact', sublabel_en: 'Contact details' },
  { key: 'needs', label_fr: 'Offre', label_en: 'Offering', sublabel_fr: 'Votre offre', sublabel_en: 'Your offering' },
  { key: 'projects', label_fr: 'Besoins', label_en: 'Needs', sublabel_fr: 'Projets en cours', sublabel_en: 'Current projects' },
  { key: 'preferences', label_fr: 'Préférences', label_en: 'Preferences', sublabel_fr: 'Format de rencontre', sublabel_en: 'Meeting format' },
  { key: 'review', label_fr: 'Validation', label_en: 'Review', sublabel_fr: 'Confirmer les détails', sublabel_en: 'Confirm details' },
];

export const STEPS_POP_B = [
  { key: 'personal', label_fr: 'Informations', label_en: 'Personal Info', sublabel_fr: 'Informations personnelles', sublabel_en: 'Basic information' },
  { key: 'expertise', label_fr: 'Expertise', label_en: 'Professional', sublabel_fr: 'Votre expertise', sublabel_en: 'Your expertise' },
  { key: 'portfolio', label_fr: 'Portfolio', label_en: 'Portfolio', sublabel_fr: 'Vos projets', sublabel_en: 'Your projects' },
  { key: 'preferences', label_fr: 'Préférences', label_en: 'Preferences', sublabel_fr: 'Format de rencontre', sublabel_en: 'Meeting format' },
  { key: 'review', label_fr: 'Validation', label_en: 'Review', sublabel_fr: 'Confirmer les détails', sublabel_en: 'Confirm details' },
];

// Initial form data for Pop A registration
export const INITIAL_POP_A_DATA = {
  company_name: '',
  representative_1: { name: '', firstname: '', email: '', phone: '', landline: '', job_title: '' },
  representative_2: { name: '', firstname: '', email: '', phone: '', landline: '', job_title: '' },
  specialties: [],
  search_criteria: [],
  artisanat: false,
  artisanat_prefs: { types: [], scale: [], export: [], precisions: '' },
  mobilier: false,
  mobilier_prefs: { types: [], materials: [], scale: [], export: [], precisions: '' },
  recherche_prefs: { model: [], process: [], production: [], flexibility: [], precisions: '' },
  projects: [],
  attendance_mode: 'both',
  metadata: {
    adherent_cotisant: [],
    offre: '',
    savoir_faire: '',
    place_du_design: [],
    comments: '',
  },
};

// Initial form data for Pop B registration
export const INITIAL_POP_B_DATA = {
  company_name: '',
  representative_1: { name: '', firstname: '', email: '', phone: '', landline: '', job_title: '' },
  representative_2: { name: '', firstname: '', email: '', phone: '', landline: '', job_title: '' },
  expertise_types: [],
  artisanat: false,
  artisanat_prefs: { types: [], scale: [], export: [], precisions: '' },
  mobilier: false,
  mobilier_prefs: { types: [], materials: [], scale: [], export: [], precisions: '' },
  recherche_prefs: { model: [], process: [], production: [], flexibility: [], precisions: '' },
  portfolio_projects: [],
  attendance_mode: 'both',
  metadata: {
    profil_createur: [],
    savoir_faire: '',
    materiaux_techniques: '',
    demarche_creative: '',
    comments: '',
  },
};

// ==================== SDO-SPECIFIC CONSTANTS ====================

export const ADHERENT_OPTIONS = [
  { value: 'codifab', label: 'CODIFAB' },
  { value: 'ameublement_francais', label: 'Ameublement français' },
  { value: 'unama', label: 'UNAMA' },
  { value: 'aucun', label: 'Aucun' },
];

export const PLACE_DU_DESIGN_OPTIONS = [
  { value: 'designers_internes', label_fr: 'Vous avez des designers internes', label_en: 'You have internal designers' },
  { value: 'bureau_etude', label_fr: 'Vous avez un bureau d\'étude intégré', label_en: 'You have an integrated design office' },
  { value: 'collab_ponctuelle', label_fr: 'Vous collaborez de manière ponctuelle avec des designers externes', label_en: 'You collaborate occasionally with external designers' },
  { value: 'directeur_artistique', label_fr: 'Vous avez un directeur artistique', label_en: 'You have an art director' },
  { value: 'premiere_collab', label_fr: 'Vous participez pour développer une première collaboration avec un designer externe', label_en: 'You participate to develop a first collaboration with an external designer' },
];

export const PROFIL_CREATEUR_OPTIONS = [
  { value: 'designer_produit', label_fr: 'Designer produit', label_en: 'Product designer' },
  { value: 'designer_architecte', label_fr: 'Designer produit et architecte d\'intérieur', label_en: 'Product designer and interior architect' },
  { value: 'directeur_artistique', label_fr: 'Directeur artistique', label_en: 'Art director' },
];

export const SDO_PORTFOLIO_CONFIDENTIALITY = [
  { value: 'public', label_fr: 'Public', label_en: 'Public' },
  { value: 'confidentiel', label_fr: 'Confidentiel', label_en: 'Confidential' },
];

// Status badge colors (used in admin views)
export const STATUS_COLORS = {
  draft: { bg: '#f0f0f0', text: '#666', label_fr: 'Brouillon', label_en: 'Draft' },
  submitted: { bg: '#e8f4f8', text: '#2980b9', label_fr: 'Soumis', label_en: 'Submitted' },
  validated: { bg: '#e8f8e8', text: '#27ae60', label_fr: 'Validé', label_en: 'Validated' },
  rejected: { bg: '#f8e8e8', text: '#e74c3c', label_fr: 'Refusé', label_en: 'Rejected' },
  pending: { bg: '#fff8e8', text: '#f39c12', label_fr: 'En attente', label_en: 'Pending' },
  confirmed: { bg: '#e8f8e8', text: '#27ae60', label_fr: 'Confirmé', label_en: 'Confirmed' },
  waitlisted: { bg: '#f0e8f8', text: '#8e44ad', label_fr: 'Liste d\'attente', label_en: 'Waitlisted' },
};
